export default __webpack_public_path__ + "static/media/plain-sticker-s.d2d15382.png";